import React from "react";

const AddIcon = ({style}) => {
    return <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path d="M10.4047 21.463L10.405 1.57836C10.405 0.961892 10.9045 0.462354 11.521 0.462354C12.1375 0.462354 12.637 0.961892 12.637 1.57836L12.637 21.4633C12.637 22.0797 12.1375 22.5793 11.521 22.5793C10.9045 22.5793 10.4047 22.0795 10.4047 21.463Z" />
    <path d="M1.57857 10.4048H21.4634C22.0799 10.4048 22.5794 10.9043 22.5794 11.5208C22.5794 12.1373 22.0799 12.6368 21.4634 12.6368L1.57834 12.6366C0.962091 12.6368 0.462303 12.1371 0.462542 11.5208C0.462303 10.9046 0.96209 10.4048 1.57857 10.4048Z" />
  </svg>
};

export default AddIcon;